var gnosis = angular.module('gnosis',['ui.bootstrap','ngMaterial','ngMessages']).config(["$mdThemingProvider", function($mdThemingProvider) {
  $mdThemingProvider.theme('default')
    .primaryPalette('grey')
    .accentPalette('grey');
}]);

////////////////////////////////////////////////////////////////////////////////////
//Core System
	gnosis.controller('core', ['$scope', '$uibModal', function($scope, $uibModal){
      
  
      
      
        $scope.checkout = function(){
      	jcart.submit();
          
          console.log('test');
      }
      
      //Various Flag Values
      $scope.max = 0;
      $scope.jars = {};
      $scope.gifts = false;
      $scope.message = false;
	  $scope.logo = false;
      $scope.load = false;
      $scope.hidebtn = false;
      $scope.nyc = false;
      $scope.national = false;
      $scope.choosetxt = 'default';
      $scope.selected = '';
      $scope.textInputValid = false;
      
      //Calculate How Many Jars 
      $scope.calc = function(){
        $scope.selected = '';
        $scope.tally = 0;
        angular.forEach($scope.jars, function(value, key) {
  			$scope.tally = $scope.tally + value.qty;
          if(value.qty){
            if($scope.selected != '') $scope.selected = $scope.selected + ', ';
          	$scope.selected = $scope.selected + value.qty + ' ' + value.name;
          }
		});
        return $scope.tally;
      }
      
      //Return amount of Jars Available
      $scope.left = function(){
        return $scope.max - $scope.calc();
      }
      	
      //Opens Modal Window
      $scope.modal = function(template){
			 var modalInstance = $uibModal.open({
                  templateUrl: template,
                  size: 'md',
                  controller: 'modal',
                  windowClass: 'my_modal',
              });
      }
      
      //Add to Cart Loader Function
      $scope.add = function(){
        if($scope.logo) $scope.load = true;
        $scope.hidebtn = true;
      }
      
        $scope.inputLoaded = function(){
        if($scope.logo) $scope.load = true;
        $scope.hidebtn = true;
      }
      
      
      //Minimum Date
      $scope.myDate = new Date();
      
      $scope.minDate = new Date(
        $scope.myDate.getFullYear(),
        $scope.myDate.getMonth(),
        $scope.myDate.getDate()+2
      );
      
      function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

          if (month.length < 2) month = '0' + month;
          if (day.length < 2) day = '0' + day;

          return [year, month, day].join('-');
        }
      
      //NYC Shipping Days
      $scope.nycship = function(date) { 
        var showDate = true;
        
        // add all ur dates to disable here as a new line 
        //seperate by commas, dont put comma for the last date alone
        
        var dateRangeToDisable = [new Date("2023-11-24"),
                                  new Date("2023-11-25"),
                                  new Date("2023-11-26"),
                                  new Date("2023-12-26"),
                                  new Date("2023-12-27"),
                                  new Date("2024-01-02"),
                                  new Date("2024-01-03"),
                                  
                                                   
                                 ];
                                  
                                  
		
        
        
        
        angular.forEach(dateRangeToDisable, function(item) {
          
            if (formatDate(item) === formatDate(date)) {
              console.log("item: " + formatDate(item));
          console.log("date:" + formatDate(date));
            showDate = false;
            }
          });
        if(showDate == false) return showDate;
        else {
        var day = date.getDay();
        if(day === 1 && $scope.national) return false;
        if(day != 1 && day > 0 && day < 6 && !$scope.nyc) return true;
        if(day > 0 && day < 6) return true;
        }

         return false;
      }

      $scope.updateCart = function(){
      	console.log('update');
        document.getElementById('jupdate').click();
        console.log(document.getElementById('jupdate'));
      }
    
      }]);
      

////////////////////////////////////////////////////////////////////////////////////
// Generic Modal Controller
	gnosis.controller('modal', ['$scope', function($scope ){
		 

}]);


